import { Empty } from 'antd';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { getAccess, log } from 'utils';
import { bulkInformation } from 'state/actions/information';
// import { regexInput } from 'utils/regex';
// import Table from 'components/Table';
import _ from 'underscore';
import { EmptyIcon } from 'assets/icon/bigicon';
import { FilterIcon } from 'assets/icon';
import ModalInformationCategoryForm from 'components/ModalInformationCategoryForm';
import {
  createInformationCategory,
  deleteInformationCategory,
  modifyInformationCategory,
  setInformationCategory,
} from 'state/actions/informationCategories';
import ModalDelete from 'components/ModalDelete';
import Cards from 'design-components/Cards';
import CategoryDropdown from 'components/CategoryDropdown';
import './WebPagesPage.scss';
import './WebPagesPage.css';
import {
  setInfoCategory,
  setTabInformation,
} from '../../state/actions/breadcrumb';
import { deleteWebLayout, fetchWebLayout } from 'state/actions/webLayout';
import AddWebLayoutConfigForm from './AddWebLayoutConfig';

const WebLayoutConfigPage = ({ history }) => {
  const { siteId, siteName } = useParams();

  const {
    informationCategories,
    selectedCategory,
    loading,
    userData,
    role,
    updated,
    category,
    selectedTab,
    categoryLoading,
    webLayoutData,
  } = useSelector(
    (state) => ({
      selectedCategory: state.breadcrumb.infoCategory,
      informationCategories: state.informationCategories.list,
      loading: state.webPages.loading,
      deleted: state.webPages.deleted,
      userData: state.auth.userData,
      updated: state.webPages.updated,
      role: state.auth.userData.role,
      category: state.informationCategories.category,
      selectedTab: state.breadcrumb.information,
      categoryLoading: state.informationCategories.loading,
      webLayoutData: state.webLayout.list,
    }),
    shallowEqual
  );

  const [deleteModal, setDeleteModal] = useState({
    information: null,
    isOpen: false,
  });

  const dispatch = useDispatch();

  const [search, setSearch] = useState();
  const [tempSelectedCategory, setTempSelectedCategory] =
    useState(selectedCategory);
  const [playlistOpen, setPlaylistOpen] = useState(false);

  const [modalCategory, setModalCategory] = useState(false);
  const [dragDropElement, setDragDropElement] = useState({
    dragged: '',
    enter: '',
  });
  const [modalDeleteCategory, setModalDeleteCategory] = useState({
    show: false,
    category: null,
  });

  const [access, setAccess] = useState(null);

  const uid = userData.id;

  useEffect(() => {
    dispatch(fetchWebLayout({ siteId }));
  }, []); // eslint-disable-line

  useEffect(() => {
    if (userData?.roleAccess) {
      setAccess(getAccess(userData, 'layoutConfig', siteId));
    }
  }, [userData, siteId]);

  const handleSearch = (e) => {
    // setSearchError(null);
    // if (!regexInput(e.target.value) && e.target.value) {
    //   setSearchError('Search cannot using special character');
    // }
    setSearch(e.target.value);
  };

  const dataByCategory = webLayoutData.filter((information) => {
    return selectedCategory !== 'all'
      ? information.categoryId === selectedCategory
      : true;
  });

  const filteredData = search
    ? webLayoutData.filter((el) => {
        const clonedElem = { ...el };
        return clonedElem.name.toLowerCase().includes(search.toLowerCase());
      })
    : dataByCategory;

  // const confirmMessage = useFormatMessage('Information.confirm');

  // const permDeleteMessage = useFormatMessage('Information.permDelete');

  const getCategory = (categoryId) => {
    const findCategory = informationCategories.find(
      (cat) => cat._id === categoryId
    );
    return findCategory?.name;
  };

  const handleSetPlaylist = () => {
    dispatch(setInfoCategory(tempSelectedCategory));
    setPlaylistOpen(false);
  };

  const handleEdit = (data) => {
    setSelectedPostData(data);
    setShowAddPage(true);
  };

  const onSubmitCategory = () => {
    const action = category._id
      ? modifyInformationCategory
      : createInformationCategory;

    dispatch(
      action({ uid, ...category, siteId, id: category._id }, () =>
        setModalCategory(false)
      )
    );
  };

  const handleSetCategory = (data) => {
    dispatch(setInformationCategory(data));
  };

  const handleEditCategory = (category) => {
    // setIsEditing(true);
    dispatch(setInformationCategory(category));
    setModalCategory(true);
  };

  const handleDeleteCategory = (category) => {
    setModalDeleteCategory({
      show: true,
      category,
    });
  };

  const onDeleteCategory = () => {
    dispatch(
      deleteInformationCategory(modalDeleteCategory.category._id, () =>
        onCloseModalCategoryHandler()
      )
    );
  };

  const onCloseModalCategoryHandler = () => {
    setModalDeleteCategory({
      show: false,
      category: null,
    });
  };

  const handleNew = () => {
    dispatch(
      setInformationCategory(
        {
          _id: '',
          name: '',
          description: '',
        },
        () => setModalCategory(true)
      )
    );
  };
  const onCloseModalHandler = () => {
    setDeleteModal({ information: null, id: null, isOpen: false });
  };

  const [showAddPage, setShowAddPage] = useState(false);

  const [selectedPostData, setSelectedPostData] = useState([]);

  const onRemoveButtonClickHandler = (information) => {
    setDeleteModal({
      information,
      isOpen: true,
    });
  };

  const onDeleteWebPageHandler = () => {
    dispatch(
      deleteWebLayout(deleteModal.information, () => {
        onCloseModalHandler();
      })
    );
  };

  return showAddPage ? (
    <AddWebLayoutConfigForm
      predefinedData={selectedPostData}
      error={''}
      onClose={() => setShowAddPage(false)}
    />
  ) : (
    <div className="web-page-library">
      <ModalDelete
        isVisible={modalDeleteCategory.show}
        onOk={onDeleteCategory}
        onCancel={onCloseModalCategoryHandler}
        title="Delete Category"
        subtitle={
          modalDeleteCategory.category ? modalDeleteCategory.category.name : ''
        }
        loading={categoryLoading}
      />

      <ModalDelete
        isVisible={deleteModal.isOpen}
        onOk={onDeleteWebPageHandler}
        onCancel={onCloseModalHandler}
        title="Delete Layout"
        subtitle={deleteModal.information ? deleteModal.information.name : ''}
        loading={loading}
      />

      <ModalInformationCategoryForm
        visible={modalCategory}
        onCancel={() => {
          setModalCategory(false);
        }}
        onCreate={onSubmitCategory}
        category={category}
        setCategory={handleSetCategory}
        isEditing={!!category._id}
      />

      <div className="web-page-header">
        <div className="web-page-header-left">
          <div className="searchbar-wrapper">
            <div className="searchbar">
              <i className="feather-search" />
              <input
                placeholder="Search"
                className="search-input"
                // value={search}
                onChange={handleSearch}
              />
            </div>
          </div>
          <div
            className="playlist-wrapper"
            onClick={() => setPlaylistOpen(!playlistOpen)}
          >
            <div className="playlist-selection">
              <FilterIcon />
              <span>
                {selectedCategory === 'all'
                  ? 'Show All'
                  : getCategory(selectedCategory)}
              </span>
            </div>
            <i
              className={`feather-chevron-down ${
                playlistOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={informationCategories}
              setTempSelectedCategory={(id) => setTempSelectedCategory(id)}
              handleEditCategory={
                role === 'superadmin' ? (cat) => handleEditCategory(cat) : null
              }
              handleDeleteCategory={
                role === 'superadmin'
                  ? (cat) => handleDeleteCategory(cat)
                  : null
              }
              modalOpen={playlistOpen}
              handleSetPlaylist={handleSetPlaylist}
              tempSelectedCategory={tempSelectedCategory}
              handleNew={role === 'superadmin' ? handleNew : null}
              filter
            />
          </div>
        </div>
        <div className="actions__wrapper">
          {(role === 'superadmin' || (access && access.create)) && (
            <div
              onClick={() => {
                setShowAddPage(true);
                setSelectedPostData([]);
              }}
              className="btn-primary"
            >
              <i className="feather-plus mr-2" />
              Add New Config
            </div>
          )}
        </div>
      </div>

      <div className="web-page-content-wrapper">
        <div className="web-page-content">
          <div className="web-page-list-content">
            {webLayoutData.length > 0 && filteredData.length > 0 ? (
              _.chunk(filteredData, 3).map((chunk, index) => {
                return (
                  <div className="web-page-list-chunk" key={index}>
                    {chunk.map((data) => {
                      return (
                        <div
                          key={data._id}
                          data-id={data._id}
                          className={`web-page-list ${
                            dragDropElement.dragged === data._id
                              ? 'dragged'
                              : ''
                          } ${
                            dragDropElement.enter === data._id ? 'entered' : ''
                          }`}
                          draggable
                          onDragStart={() =>
                            setDragDropElement({
                              ...dragDropElement,
                              dragged: data._id,
                            })
                          }
                          onDragEnd={() =>
                            setDragDropElement({
                              ...dragDropElement,
                              dragged: '',
                            })
                          }
                          onDragEnter={() => {
                            setDragDropElement({
                              ...dragDropElement,
                              enter: information._id,
                            });
                          }}
                          onDragOver={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                          onDrop={(e) => {
                            e.stopPropagation();
                            const findInfo = informationList.find(
                              (info) => info._id === dragDropElement.dragged
                            );
                            const sourceSequence = findInfo.sequence;
                            const newInfo = [...informationList];
                            const findSource = newInfo.find(
                              (x) => x._id === findInfo._id
                            );

                            if (findSource) {
                              findSource.sequence = information.sequence;
                            }

                            const findTarget = newInfo.find(
                              (x) => x._id === information._id
                            );

                            if (findTarget) {
                              findTarget.sequence = sourceSequence;
                            }
                            dispatch(
                              bulkInformation({
                                data: _.sortBy(newInfo, 'sequence'),
                                siteId,
                              })
                            );

                            setDragDropElement({
                              dragged: '',
                              enter: '',
                            });
                          }}
                        >
                          <Cards
                            data={data}
                            type="web-layout"
                            isShowinformation
                            isDelete={true}
                            editAction={() => handleEdit(data)}
                            deleteAction={() =>
                              onRemoveButtonClickHandler(data._id)
                            }
                          />
                        </div>
                      );
                    })}
                    {chunk.length < 2 && (
                      <div className="web-page-list-empty" />
                    )}
                    {chunk.length < 3 && (
                      <div className="web-page-list-empty" />
                    )}
                  </div>
                );
              })
            ) : (
              <div className="web-page-empty">
                <Empty image={<EmptyIcon />} description="No Page" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebLayoutConfigPage;
